import React from "react";
import ReactDOM from "react-dom/client";
import { AppContextProvider } from "./AppContext/AppContext";
import "./index.css";
import App from "./App";
import Analytics from "./Utilities/Analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppContextProvider>
    <App />
    <Analytics />
  </AppContextProvider>
);
